import axios from 'axios'
import { get, post, del } from '@/http/request'
import { HOST } from '@/http/config'

console.log(HOST, 'url')

// test
export function getProcurementList(params) {
  return get(`${HOST}b-fixedasset/list/`, params)
}
// 新增固定资产申请
export function saveProcurement(params) {
  return post(`${HOST}b-fixedasset/save`, params)
}
// 修改固定资产申请
export function updateProcurement(params) {
  return post(`${HOST}b-fixedasset/update/`, params)
}
// 根据id删除固定资产
export function deleteProcurement(params) {
  return del(`${HOST}b-fixedasset/delete`, params)
}
// 固定资产详情
export function getProcurementDetail(params) {
  return get(`${HOST}b-fixedasset/get`, params)
}
//组织结构树
export function getTreeList(params) {
  return get(`${HOST}organization-info/treeList/`, params)
}
// 固定资产处置
export function getDispositionList(params) {
  return get(`${HOST}d-fixe-dasset/list/`, params)
}
// 新增固定资产处置
export function saveDisposition(params) {
  return post(`${HOST}d-fixe-dasset/save`, params)
}
// 修改固定资产处置
export function updateDisposition(params) {
  return post(`${HOST}d-fixe-dasset/update/`, params)
}
// 根据id删除固定处置
export function deleteDisposition(params) {
  return del(`${HOST}d-fixe-dasset/delete`, params)
}
// 固定资产处置详情
export function getDispositionDetail(params) {
  return get(`${HOST}d-fixe-dasset/get/`, params)
}
//根据类型查询字典下拉列表
export function listByType(params) {
  return get(`${HOST}sys-dict/listByType`, params)
}


// WEBPACK FOOTER //
// ./src/views/FixedAssets/api/api.js